import { THEME_VARIABLE } from '@/config';
import { Flex, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { Heading } from '../../Heading';
import { AddIcon, SearchIcon } from '../../Icons';
import { useState } from 'react';
import TeamMemberCardItem from './TeamMemberCardItem';
import TeamMemberModal from './TeamMemberModal/TeamMemberModal';
import AddRoleModal from './TeamMemberModal/AddRoleModal';
import { useFetchTeamMembers } from '@/hooksApi';
import { useFetchRoles } from '@/hooksApi';
import { useDeleteRole, useDeleteTeamMember } from '@/hooksApi';
import { useQueryClient } from '@tanstack/react-query';
import { TeamMember, Role } from '@/types';
import RoleCardItem from './RoleCardItem';

const TeamMemberSection = () => {
  const [teamMemberModalData, setTeamMemberModalData] = useState<TeamMember | undefined>(undefined);
  const [roleModalData, setRoleModalData] = useState<Role | undefined>(undefined);

  const [teamMemberModalUID, setTeamMemberModalUID] = useState<string | undefined>(undefined);
  const [roleModalUID, setRoleModalUID] = useState<string | undefined>(undefined);

  const { t } = useTranslation();

  const queryClient = useQueryClient();

  const { data: teamMemberData } = useFetchTeamMembers();

  const { data: roleData } = useFetchRoles();

  const { mutateAsync: deleteTeamMember, isLoading: isDeletingTeamMember } = useDeleteTeamMember();

  const { mutateAsync: deleteRole, isLoading: isDeletingRole } = useDeleteRole();

  const handleDeleteTeamMember = (uid: string) => {
    deleteTeamMember(uid, {
      onSuccess: () => {
        queryClient.invalidateQueries(['teamMember-users']);
      },
    });
  };

  const handleEditTeamMember = (teamMember: TeamMember) => {
    setTeamMemberModalData(teamMember);
    setTeamMemberModalUID(teamMember.uid);
  };

  const handleDeleteRole = (uid: string) => {
    deleteRole(uid, {
      onSuccess: () => {
        queryClient.invalidateQueries(['teamMember-roles']);
        queryClient.invalidateQueries(['teamMember-users']);
      },
    });
  };

  const handleEditRole = (role: Role) => {
    setRoleModalData(role);
    setRoleModalUID(role.uid);
  };

  return (
    <Flex vertical>
      <Flex justify='space-between' className='mb-6'>
        <Heading
          fontSize='text-lg'
          fontWeight='font-medium'
          extraClassName='uppercase'
          parentClassName='mt-2'
          title={t('users')}
        />
        <Flex justify='end' gap={16}>
          {/* <Input
            size='small'
            placeholder={t('search')}
            prefix={<SearchIcon />}
            className='rounded-lg h-11 border-customGrayShade5 bg-customGrayShade1'
            allowClear
            // onChange={handleSearchInputChange}
            // defaultValue={searchValue?.search || ''}
          /> */}
          <Flex
            onClick={() => {
              setTeamMemberModalData(undefined);
              setTeamMemberModalUID('');
            }}
            className='w-[44px] min-w-11 cursor-pointer  h-[44px] flex justify-center items-center rounded-[10px] border border-solid border-customTunaPrimary'
          >
            <AddIcon width={24} height={24} color={THEME_VARIABLE.customTunaPrimary} />
          </Flex>
        </Flex>
      </Flex>
      <Flex vertical gap={16}>
        {teamMemberData?.object?.map((item) => (
          <TeamMemberCardItem
            fName={item?.first_name}
            lName={item?.last_name}
            role={item?.roles}
            key={item?.uid}
            // {...item}
            onDelete={() => handleDeleteTeamMember(item?.uid)}
            isDeleting={isDeletingTeamMember}
            onEdit={() => handleEditTeamMember(item)}
            uid={item?.uid}
          />
        ))}
      </Flex>
      <Flex justify='space-between' className='my-6'>
        <Heading
          fontSize='text-lg'
          fontWeight='font-medium'
          extraClassName='uppercase'
          parentClassName='mt-2'
          title={t('roles')}
        />
        <Flex justify='end' gap={16}>
          {/* <Input
            size='small'
            placeholder={t('search')}
            prefix={<SearchIcon />}
            className='rounded-lg h-11 border-customGrayShade5 bg-customGrayShade1'
            allowClear
            // onChange={handleSearchInputChange}
            // defaultValue={searchValue?.search || ''}
          /> */}
          <Flex
            onClick={() => {
              setRoleModalUID('');
            }}
            className='w-[44px] min-w-11 cursor-pointer  h-[44px] flex justify-center items-center rounded-[10px] border border-solid border-customTunaPrimary'
          >
            <AddIcon width={24} height={24} color={THEME_VARIABLE.customTunaPrimary} />
          </Flex>
        </Flex>
      </Flex>
      <Flex vertical gap={16}>
        {roleData?.object?.map((item) => (
          <RoleCardItem
            role={item}
            key={item.uid}
            onDelete={() => handleDeleteRole(item.uid)}
            isDeleting={isDeletingRole}
            onEdit={() => handleEditRole(item)}
          />
        ))}
      </Flex>
      <TeamMemberModal
        teamMemberUID={teamMemberModalUID}
        teamMemberData={teamMemberModalData}
        onClose={() => {
          setTeamMemberModalData(undefined);
          setTeamMemberModalUID(undefined);
        }}
        roleList={roleData?.object ?? []}
      />
      <AddRoleModal
        roleData={roleModalData}
        roleUID={roleModalUID}
        onClose={() => {
          setRoleModalUID(undefined);
          setRoleModalData(undefined);
        }}
      />
    </Flex>
  );
};

export default TeamMemberSection;
